module.exports = __webpack_public_path__ + "media/images/emblems/Walzenha-ca7262a401171afe012a6117bc714b76.png";